import React from 'react';
import { Input, Table, Space, Spin, Card, Typography, Dropdown, message, Empty, Button } from 'antd';
// import moment from 'moment';
import Dayjs from 'dayjs';
import type { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import type { FilterValue, SorterResult } from 'antd/lib/table/interface';
import { PlusSquareOutlined, MinusSquareOutlined, SearchOutlined } from "@ant-design/icons";
import { isMobile } from 'react-device-detect';
import { MenuProps } from 'antd/lib';
import { useNavigate } from 'react-router-dom';
import { SortOrder } from 'antd/es/table/interface';

interface Props {
    title?: string | any
    rowClassName?: any
    scroll?: any;
    columns: ColumnsType<any>
    refresh?: boolean
    search?: boolean
    Filter?: any
    placeholderSearch?: string
    emptyText?: any
    bordered?: boolean
    onLoadData: (data: {
        page: number
        perPage: number
        searchText?: string
        sorterField?: string
        sorterOrder?: SortOrder
        filters?: Record<string, FilterValue | null>
    }, signal: any) => Promise<any>
    defaultColumns?: boolean
    menuOptions?: MenuProps['items'] | boolean
    menuClick?: (e: any) => void
}

interface Options {
    signal?: AbortSignal
}

const items: MenuProps['items'] = [
    {
        label: 'แก้ไขหัวคอลัมน์',
        key: 'fix_columns',
        // icon: <UserOutlined />,
    },
];


const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    message.info('Click on left button.');
    console.log('click left button', e);
};

const AntTable = (props: Props) => {


    const [pagination, setPagination] = React.useState<TablePaginationConfig>({
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        position: ['topLeft', 'bottomRight']
    });
    const [columns, setColumns] = React.useState(props.columns)
    const [datas, setDatas] = React.useState<Array<any>>([])
    const [keyword, setKeyword] = React.useState<string>("")
    const [filters, setFilters] = React.useState<Record<string, FilterValue | null>>()
    const [loading, setLoading] = React.useState<boolean>(false)
    const [expandedKey, setExpandedKey] = React.useState<Array<any>>([])
    // const navigation = useNavigate();



    const handleMenuClick: MenuProps['onClick'] = (e) => {
        // message.info('Click on menu item.');
        console.log('click', e);
        if (e.key == 'fix_columns') {

        } else {
            props.menuClick && props.menuClick(e);
        }
    };


    const menuProps = {
        items,
        onClick: handleMenuClick,
    };



    const onSearch = (event: any) => {
        setKeyword(event.target.value)
    }

    /**
     * @description Search function
     */
    React.useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal
        const delayTimer = setTimeout(() => {

            if (keyword) {
                loadData({
                    newPagination: {
                        current: 1,
                        pageSize: 10,
                    },
                    searchText: keyword,
                    filters: filters
                }, { signal: signal })
            } else {
                loadData({
                    newPagination: {
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                    },
                    searchText: keyword,
                    filters: filters
                }, { signal: signal })
            }

        }, !keyword ? 0 : 500);

        return () => {
            clearTimeout(delayTimer)
            controller.abort();
        }
    }, [keyword, props.refresh])

    const loadData = async ({ sortField, sortOrder, newPagination, searchText, filters }: { sortField?: string, sortOrder?: SortOrder, newPagination: TablePaginationConfig, searchText?: string, filters?:Record<string, FilterValue | null>, }, options: Options = {}): Promise<any> => {
        setLoading(true)

        const res = await props.onLoadData({
            page: newPagination.current || 1,
            perPage: newPagination.pageSize || 10,
            sorterField : sortField,
            sorterOrder: sortOrder,
            searchText: searchText || keyword,
            filters: filters
        }, options).finally(() => {
            setLoading(false)
        })



        if (res?.data) {

            if (props.defaultColumns) {
                customColumnsByDefault(Object.keys(res.data?.[0] || []))
            }

            setDatas(res.data)
            setExpandedKey(res.data.map((item: { key: string }) => item?.key))
            const { total } = res.meta
            setPagination({
                ...pagination,
                current: newPagination.current,
                pageSize: newPagination.pageSize || 10,
                total: total
            });
        }

        return res
    }

    const customColumnsByDefault = (columns: Array<any>) => {
        const newColumns: Array<any> = columns.map(column => {
            return {
                title: column,
                dataIndex: column,
                align: 'center',
                render: (value: any, record: any) => {
                    if (Dayjs(value).isValid() && !(/^\d+$/.test(value))) { //not equal number also
                        return Dayjs(value).format('YYYY-MM-DD')
                    } else {
                        return value
                    }
                }
            }
        })
        setColumns(newColumns)
    }

    const handleTableChange = (
        newPagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<any> | any,
    ) => {

        setFilters(filters);
        loadData({
            sortField: sorter.field as string,
            sortOrder: sorter.order as SortOrder,
            newPagination: newPagination,
            filters: filters
        })
    };

    return (
        <div>




            <Space align="end" style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16, marginBottom: 16 }}>

                {
                    props?.search ?
                        <Input
                            prefix={<SearchOutlined />}
                            size={'small'}
                            onChange={onSearch}
                            allowClear={true}
                            placeholder={props?.placeholderSearch || "Search"}
                            style={{ fontSize: 13, minWidth: 300, border: '0px', borderBottom: '1px solid #ccc' }} />

                        :
                        null
                }

                &nbsp;&nbsp;
                {
                    props.Filter || null
                }

            </Space>





            <Card
                bordered={false}
                className="criclebox tablespace mb-24"
                title={<Typography.Title level={4} >{props.title || ""} <span style={{ fontSize: 14, color: 'gray', fontWeight: 'bold' }}>({pagination.total})</span></Typography.Title>}
                extra={
                    <>
                        {
                            props.menuOptions === false ?
                                null
                                :
                                <Dropdown.Button menu={{
                                    items: [
                                        ...menuProps.items,
                                        ...(props.menuOptions != true && props.menuOptions != undefined ? props.menuOptions : [])
                                    ],
                                    onClick: menuProps.onClick
                                }} onClick={handleButtonClick}>
                                    ปรับแต่ง
                                </Dropdown.Button>
                        }

                    </>
                }
            >
                <div className="table-responsive">
                    <Table
                        // tableLayout={undefined}
                        style={{ padding: 20 }}
                        className="ant-border-space"
                        rowClassName={props.rowClassName || ''}
                        defaultExpandAllRows={true}
                        expandable={{
                            expandIcon: ({ expanded, onExpand, record }) => {

                                if (!record?.header) {
                                    return null;
                                }

                                if (expanded) {
                                    return <MinusSquareOutlined onClick={e => onExpand(record, e)} style={{ paddingRight: 5, margin: 7, fontSize: 16, color: '#6e6e6e' }} />
                                } else {
                                    return <PlusSquareOutlined onClick={e => onExpand(record, e)} style={{ paddingRight: 5, margin: 7, fontSize: 16, color: '#6e6e6e' }} />
                                }
                            }
                            ,
                            // expandedRowRender: record => <p style={{ margin: 0 }}>{record.bu}</p>,
                            // rowExpandable: record => record.key != 'A1',
                            onExpand: (_, { key }) => {
                                const i = expandedKey.findIndex(item => item == key)
                                if (i >= 0) {
                                    delete expandedKey[i]
                                    setExpandedKey(expandedKey)
                                } else {
                                    setExpandedKey(p => [...p, key])
                                }

                            },
                            expandedRowKeys: expandedKey
                        }}
                        scroll={props?.scroll == undefined ? props?.scroll : { x: isMobile ? 0 : 800 }}
                        loading={loading ? { indicator: <div><Spin /></div> } : false}
                        columns={columns}
                        dataSource={datas}
                        locale={{ emptyText: <Empty description={props?.emptyText ? props.emptyText : 'No Data'}></Empty> }}
                        rowKey={record => record.key}
                        bordered={props.bordered || false}
                        pagination={pagination}
                        onChange={(pagination, filters, sorter, extra) => handleTableChange(pagination, filters, sorter)}
                    ></Table>
                </div>
            </Card>
        </div >
    )
}

export default AntTable;
